<nav class="app-pagination" aria-label="Pagination">
	<div class="app-pagination__group" role="list">
		@if (boundaryLinks()) {
			<button
				type="button"
				class="app-pagination__btn app-pagination__btn--fixed"
				[disabled]="isFirstPage()"
				(click)="onGoToFirst()"
			>
				First
			</button>
		}

		<button
			type="button"
			class="app-pagination__btn app-pagination__btn--previous"
			[disabled]="isFirstPage()"
			(click)="onGoToPrevious()"
		>
			Previous
		</button>

		@for (pageNumber of pages(); track pageNumber) {
			<button
				type="button"
				class="app-pagination__btn app-pagination__btn--fixed"
				[class.app-pagination__btn--active]="pageNumber === currentPage()"
				[attr.aria-current]="pageNumber === currentPage() ? 'page' : null"
				(click)="onGoToPage(pageNumber)"
			>
				{{ pageNumber }}
			</button>
		}

		<button
			type="button"
			class="app-pagination__btn app-pagination__btn--fixed"
			[disabled]="isLastPage()"
			(click)="onGoToNext()"
		>
			Next
		</button>

		@if (boundaryLinks()) {
			<button
				type="button"
				class="app-pagination__btn app-pagination__btn--fixed"
				[disabled]="isLastPage()"
				(click)="onGoToLast()"
			>
				Last
			</button>
		}
	</div>
</nav>

